<template>
  <div>
      <div :style="drawerStyle" class="mu-drawer" :class="{'open': open, 'right': right}">
          <div class="mu-paper" :class="paperClass">
            <slot></slot>
          </div>    
      </div>
      <div class="mu-all" :style="display" @click="handleClose"></div>
  </div>
  
</template>

<script>
import PopupManager from './managerPopup'
import {getZIndex} from './utils'
const transitionEvents = ['msTransitionEnd', 'mozTransitionEnd', 'oTransitionEnd', 'webkitTransitionEnd', 'transitionend']

export default {
  name: 'XR-drawer',
  props: {
    right: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    },	
    display: {
      type: String,
      default: 'display:none'
    },
    docked: {
      type: Boolean,
      default: true
    },
    width: {
      type: [Number, String]
    },	
    circle: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: true
    },
    zDepth: {
      type: Number,
      default: 2
    }
  },
  data () {
    return {
      overlayZIndex: getZIndex(),
      zIndex: getZIndex()
    }
  },
  computed: {
    drawerStyle () {
      return {
        width: this.getWidth(this.width),
        'z-index': this.docked ? '' : this.zIndex
      }
    },	
    paperClass () {
      var arr = []
      if (this.circle) arr.push('mu-paper-circle')
      if (this.rounded) arr.push('mu-paper-round')
      arr.push('mu-paper-' + this.zDepth)
      return arr
    },
    overlay () {
      return !this.docked
    }
  },
  methods: {
    getWidth (w) {
		let width = String(w)
		if (width && width.indexOf('%') === -1 && width.indexOf('px') === -1) width += 'px'
		return width
    },
    overlayClick () {
      this.$emit('close', 'overlay')
    },
    closeDrawer(){
      this.rightDrawer = false
      this.display = "display:none"
    },
    handleClose(){
      console.log(this)
      this.$parent.$parent.rightDrawer = false
      this.display = "display:none"
    },
    bindTransition () {
      this.handleTransition = (e) => {
        if (e.propertyName !== 'transform') return
        this.$emit(this.open ? 'show' : 'hide')
      }
      transitionEvents.forEach((eventName) => {
        this.$el.addEventListener(eventName, this.handleTransition)
      })
    },
    unBindTransition () {
      if (!this.handleTransition) return
      transitionEvents.forEach((eventName) => {
        this.$el.removeEventListener(eventName, this.handleTransition)
      })
    },
    resetZIndex () {
      this.overlayZIndex = getZIndex()
      this.zIndex = getZIndex()
    }
  },
  watch: {
    open (val) {
      if (val && !this.docked) {
        PopupManager.open(this)
		this.display = "display:block"
      } else {
        PopupManager.close(this)
		this.display = "display:none"
      }
    },
    docked (val, oldVal) {
      if (val && !oldVal) {
        PopupManager.close(this)
		this.display = "display:none"
      }
    }
  },
  mounted () {
    if (this.open && !this.docked) PopupManager.open(this)
    this.bindTransition()
  },
  beforeDestroy () {
    PopupManager.close(this)
    this.unBindTransition()
  }
}
</script>

<style>
.mu-all{
  position: fixed;
  width:100%;
  height:100%;
  background:rgba(0,0,0,0.1);
  left:0;
  top:0;
  z-index:998;
}
.mu-drawer{
  background: #fff;
}
.mu-drawer .mu-paper{
  box-shadow:none;
}
/* .mu-all{
  position: fixed;
  width:100%;
  height:100%;
  background:rgba(0,0,0,0.4);
  left:0;
  top:0;
  z-index:1;
} */
</style>



// WEBPACK FOOTER //
// src/components/drawer/drawer.vue